/* eslint-disable react/prop-types */
import HomeComponent from "./home";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { LINKS } from "@/static-texts/links";
function Home({ content }) {
  const history = useHistory();

  const handleFindOutClick = () => {
    history.push(LINKS.BUILD_YOUR_SOLUTION);
  };

  return (
    <HomeComponent onFindOutClick={handleFindOutClick} content={content} />
  );
}

export default Home;
